// extracted by mini-css-extract-plugin
export default {"header":"sT0mgh2K"};